import React from 'react'
import { CheckCircle2, Circle } from 'lucide-react'
import styles from './PortfolioProgressSection.module.scss'

type PortfolioItem = { key: string; label: string; done: boolean; value?: string }

const PortfolioProgressSection: React.FC<{
  portfolioItems: PortfolioItem[]
  summaryImageUrl?: string
}> = ({ portfolioItems, summaryImageUrl }) => {
  if (!portfolioItems.length) return null
  return (
    <div className={styles.portfolioProgress}>
      <div
        className={styles.portfolioProgressBar}
        style={{
          width: `${(portfolioItems.filter(i => i.done).length / portfolioItems.length) * 100}%`
        }}
      />
      <div className={styles.portfolioProgressHeader}>
        <span className={styles.portfolioProgressCount}>
          {portfolioItems.filter(i => i.done).length}/{portfolioItems.length} completados
        </span>
      </div>
      <div className={styles.portfolioProgressList}>
        {portfolioItems.map((item) => (
          <div
            key={item.key}
            className={`${styles.portfolioProgressItem} ${item.done ? styles.portfolioItemDone : styles.portfolioItemPending}`}
          >
            {item.done ? (
              <CheckCircle2 size={18} className={styles.portfolioIconDone} aria-hidden />
            ) : (
              <Circle size={18} className={styles.portfolioIconPending} aria-hidden />
            )}
            <span className={styles.portfolioLabel}>{item.label}</span>
            {item.done && item.value && item.key !== 'image_uploaded' && (
              <span className={styles.portfolioValue} title={item.value}>
                {item.value.length > 20 ? `${item.value.slice(0, 18)}…` : item.value}
              </span>
            )}
            {item.done && item.key === 'image_uploaded' && summaryImageUrl && (
              <img
                src={summaryImageUrl}
                alt=""
                className={styles.portfolioSummaryImage}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default PortfolioProgressSection
